import * as React from 'react';

import Button from '../common/Button/';

import './AccountMenu.scss';
import {
  goToLogin,
  goToSwitchAccount,
  goToHome,
  goToRegister,
  goToAccount,
  registerUrl,
  accountUrl,
  goToDashboard
} from 'src/utils/navigation';

import logoutIcon from 'src/assets/logoutIcon';
import accountSetting from 'src/assets/accountSetting';
import UserModel from 'src/model/user.model';
import switchAccount from 'src/assets/switchUserIcon';
import uploadIcon from 'src/assets/uploadIcon';
import UploadPhotoModal from 'src/components/AccountMenu/components/UploadPhotoModal';
import Modal from '../common/Modal/Modal';

interface IAccountMenuProps {
  signout: () => void;
  getAccounts(): void;
  isMobile?: boolean;
  isLoggedIn: boolean;
  accountID: string;
  name: string;
  showSwitchAccounts: boolean;
  t?: any;
  location?: any;
  getUserData: () => void;
  specialUser: string;
  userData: UserModel;
  showUploadModal: boolean;
  openPhotoModal: () => void;
  scrolled?: boolean;
  // accountHasChanged: boolean;
  // changeActiveAccountFlag(flag: boolean): void;
  // changeActiveAccount(newAccountId: string, clientIdentity: string): void;
}

interface IAccountMenuState {
  floatingIsOpen: boolean;
  floatingDefaultIsOpen: boolean;
  showUploadModal: boolean;
}

export default class AccountMenu extends React.Component<
  IAccountMenuProps,
  IAccountMenuState
> {
  private wrapperRef: any;
  private clickListener: any;
  private hasMounted: boolean;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false,
      floatingDefaultIsOpen: false,
      showUploadModal: false
    };
  }

  private handleClickOutside = (event: any) => {
    if (this.hasMounted) {
      if (!this.wrapperRef.contains(event.target)) {
        this.setState({ floatingIsOpen: false });
        document.removeEventListener('click', this.clickListener, true);
      }
    }
  };

  private handleTimedClosing = () => {
    if (this.state.floatingIsOpen) {
      setTimeout(() => {
        if (this.hasMounted) {
          this.setState(
            {
              floatingIsOpen: false
            },
            () => {
              document.removeEventListener('click', this.clickListener, true);
            }
          );
        }
      }, 15000);
    }
  };

  private openPhotoModal = () => {
    this.setState({ showUploadModal: true });
  };

  private handleShowFileModal = () => {
    this.setState(prevState => ({
      showUploadModal: !prevState.showUploadModal
    }));
  };

  private handleCloseMenu = () => {
    if (this.hasMounted) {
      this.setState({ floatingIsOpen: false });
    }
  };
  private handleOpenMenu = () => {
    if (this.hasMounted) {
      this.setState({ floatingIsOpen: true });
      this.setState({ floatingDefaultIsOpen: true });
      
    }
  };

  private handleOpenMenuToggle = () => {
    if (this.state.floatingDefaultIsOpen) {
      this.setState({ floatingIsOpen: false });
      this.setState({ floatingDefaultIsOpen: false });
    } else {
      this.setState({ floatingIsOpen: true });
      this.setState({ floatingDefaultIsOpen: true });
    }
  };

  private handleToggleMenu = () => {
    if (this.hasMounted) {
      this.setState({ floatingIsOpen: !this.state.floatingIsOpen });
    }
  };

  private logOut = () => {
    this.props.signout();
    // localStorage.removeItem('orgPartnum'),
    // localStorage.removeItem('orgPartmfc')
    if (localStorage.getItem('isSamsungUser')) {
      localStorage.removeItem('isSamsungUser');
    }
    goToHome();
  };

  // private shouldGoToDashboard = () => {
  //   if (this.props.accountHasChanged) {
  //     this.props.changeActiveAccountFlag(false);
  //     goToDashboard();
  //   }
  // };

  // public componentDidUpdate = (prevProps: any, prevState: any) => {
  //   if (prevProps.accountHasChanged !== this.props.accountHasChanged) {
  //     this.shouldGoToDashboard();
  //   }
  // };

  private checkLogInStatus = () => {
    if (!this.props.isLoggedIn) {
      this.clickListener = this.handleClickOutside;
      document.addEventListener('click', this.clickListener, true);
      // Only automatically open if we are not in login route
      if (!this.props.location.pathname.includes('login')) {
        setTimeout(() => {
          if (this.hasMounted) {
            this.setState(
              {
                floatingIsOpen: false
              },
              () => {
                this.handleTimedClosing();
              }
            );
          }
        }, 1000);
      }
    }
  };

  private getFloatingMenuElements = (t: any) => {
    const name =
      this.props.isLoggedIn && this.props.userData
        ? `${this.props.userData.name}`
        : `${t('common.signIn')}`;
    const accountID =
      this.props.isLoggedIn && this.props.accountID
        ? `${this.props.accountID}`
        : `${t('common.signIn')}`;
    if (this.props.isLoggedIn) {
      return (
        <div className="logged-in">
          <p className="menu-item-heading">{t('login.myAccount')} </p>
          <div className="switch-account-section">
            <div className="">
              <p className="user-name">
                {t('common.welcome')} - {name}
              </p>
              <p className="my-account">{accountID}</p>
            </div>
            {this.props.showSwitchAccounts ? (
              <div className="switch-account">
                <img
                  src={switchAccount}
                  alt="icon"
                  className="menu-item-icon"
                  onClick={goToSwitchAccount}
                />
              </div>
            ) : null}
          </div>
          <a href={accountUrl()} className="menu-item" onClick={goToAccount}>
            <img src={accountSetting} alt="icon" className="menu-item-icon" />
            {t('account.accountSettings')}
          </a>
          {/* <span className="menu-item" onClick={e => this.openPhotoModal()}>
            <img src={uploadIcon} alt="icon" className="menu-item-icon" />
            Upload your Photo
          </span> */}
          <button role="button" tabIndex={0} className="menu-item" onClick={this.logOut}>
            <img src={logoutIcon} alt="icon" className="menu-item-icon" />
            {t('common.logOut')}
          </button>
        </div>
      );
    } else {
      return (
        <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('common.signIn')}
            action={goToLogin}
          />
          <div className="login--request">
            <p className="member">{t('login.becomeMember')}</p>{' '}
            <a className="request" href={registerUrl()} onClick={goToRegister}>
              {t('login.requestAccount')}
            </a>
          </div>
        </button>
      );
    }
  };

  public componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.getAccounts();
      this.props.getUserData();
    }
    this.checkLogInStatus();
    this.hasMounted = true;
  }

  public componentWillUnmount() {
    this.hasMounted = false;
    document.body.removeEventListener('click', this.clickListener, false);
  }

  private renderDesktop() {
    const { t } = this.props;
    const name =
      this.props.isLoggedIn && this.props.userData
        ? `${this.props.userData.name}`
        : `${t('common.signIn')}`;
    const accountID =
      this.props.isLoggedIn && this.props.accountID
        ? `${this.props.accountID}`
        : `${t('login.myAccount')}`;

    const styleClasses = {
      floatMenu: this.state.floatingIsOpen ? 'opened' : 'closed'
    };

    return (
      <>
        <div
          id="account-menu"
          onMouseOver={this.props.isLoggedIn && this.props.accountID ? this.handleOpenMenu : null}
          onMouseOut={this.props.isLoggedIn && this.props.accountID ? this.handleCloseMenu : null}
          onClick={this.props.isLoggedIn && this.props.accountID ? this.handleOpenMenuToggle : goToLogin}
        >
          <div  
            className={
              this.props.scrolled
                ? 'account-menu--my-account menu-scroll-hander'
                : 'account-menu--my-account'
            }
          >
            <div className="account-menu--info" >
              <p className="user-name">{name}</p>
            </div>
            <div className="go-to-account" onKeyDown={this.handleOpenMenu}  role="button" tabIndex={0}>
              <i className="rpds-user account-menu--avatar" />
              <button className="my-account">{accountID}</button>
              {(this.props.isLoggedIn && this.props.accountID) && <i className="rpds rpds-arrow-drop-down account-menu--dropdown" />}              
            </div>
          </div>
          <div
            ref={node => (this.wrapperRef = node)}
            className={`account-menu--floating-panel ${styleClasses.floatMenu}`}
          >
            {this.getFloatingMenuElements(t)}
          </div>
        </div>
        {this.state.showUploadModal ? (
          <UploadPhotoModal
            onCloseModal={this.handleShowFileModal}
            onUploadFile={this.handleUpload}
          />
        ) : (
          ''
        )}
      </>
    );
  }

  private handleUpload(e: any) {
    // console.log(e);
  }

  private renderMobile() {
    const { t } = this.props;
    const accountID =
      this.props.isLoggedIn && this.props.accountID
        ? `${this.props.accountID}`
        : `${t('common.signIn')}`;
    const styleClasses = {
      floatMenu: this.state.floatingIsOpen ? 'opened' : 'closed'
    };
    return (
      <div id="account-menu-mobile">
        <div className="go-to-account" onClick={this.props.isLoggedIn && this.props.accountID ? this.handleToggleMenu : goToLogin}>
          <i className="rpds-user account-menu--avatar" />
          <p className="my-account">{accountID}</p>
        </div>
        {this.state.floatingIsOpen && (
          <div
            ref={node => (this.wrapperRef = node)}
            className={`account-menu--floating-panel ${styleClasses.floatMenu}`}
          >
            {this.getFloatingMenuElements(t)}
          </div>
        )}
      </div>
    );
  }

  public render() {
    return this.props.isMobile ? this.renderMobile() : this.renderDesktop();
  }
}
